export default __webpack_public_path__ + "static/media/Wallpaper1.2fd4d46d.jpg";